import { getCall, putCall } from "./api";

/**
 * PayLoom's own console — deciding which organisations may use the product.
 *
 * These call /platform/*, which sits outside tenancy: the server refuses them
 * on an ordinary organisation session and refuses ORDINARY routes on a platform
 * session. A platform token carries no organisation, so the two are not
 * interchangeable in either direction.
 */
export const getPlatformToken = async () => await getCall({ path: "/auth/platform-token" }, "OrgLogin");

export const getPendingOrganizations = async () =>
  await getCall({ path: "/platform/organizations/pending" });

export const getDecidedOrganizations = async () =>
  await getCall({ path: "/platform/organizations/decided" });

// { status: "approved" | "rejected", note }. A rejection needs a note — the
// organisation's owner is shown it.
export const decideOrganization = async (id, input = {}) =>
  await putCall({ path: `/platform/organizations/${id}/decision`, bodyParams: input });

export const getPlatformOperators = async () => await getCall({ path: "/platform/operators" });
